const EN_CONTENT = Object.freeze({
  model: 'A5',
  heroTitle: 'ANOVATOR A5'
})

const ZH_CONTENT = Object.freeze({
  model: 'P3',
  heroTitle: 'ANOVATOR P3',
  heroDescription: '专业智能体测仪',
  scrollLabel: '滚动鼠标',
  demoLabel: '申请演示',
  featuresTitle: '全面健康评估',
  featuresDescription: 'P3支持12项功能，全面评估身体风险，打造专业级人体成分检测方案',
  functions: [
    '人体成分分析',
    '平衡能力评估',
    '身体围度评估',
    '运动能力分析',
    '心率检测',
    '肺活量测量',
    '血压检测',
    '敏捷能力评估',
    '肩关节活动度',
    '血氧饱和度',
    '体态评估',
    '检测报告'
  ],
  riskItems: ['高低肩', 'X/O型腿', '驼背', '骨盆前倾'],
  serviceCards: [
    {
      title: '医疗级测评报告多端同步',
      descriptions: [
        '检测完成后，即可生成标准化专业报告。',
        '支持打印输出，多语言报告模板满足全球使用需求。'
      ],
      image: '/static/images/product/p3/report-hand.png'
    },
    {
      title: '多期数据可视化对比分析',
      descriptions: [
        '自动汇总历史检测数据，直观展示长期变化趋势。',
        '基于数据提供个性化运动与营养建议。'
      ],
      image: '/static/images/product/p3/report-chart.png'
    },
    {
      title: '一站式健康管理平台',
      descriptions: [
        '完整管理会员档案，帮助提升私教服务效率与会员转化。',
        '设备数据实时同步，统一管理所有检测信息。',
        '会员档案与标签分类更加高效。',
        '云端与本地双重备份，保障数据安全。'
      ],
      image: '/static/images/product/p3/report-dashboard.png'
    }
  ]
})

function getA5ProductContent(language) {
  return language === 'ZH' ? ZH_CONTENT : EN_CONTENT
}

module.exports = {
  EN_CONTENT,
  ZH_CONTENT,
  getA5ProductContent
}
